import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { intialMessage, userMessage } from 'constants/ui.constants';
import _ from 'lodash';

////TODO: set types for awaitng and open pending perhaps?

interface settingsState {
	loading: boolean;
	message: userMessage;
	myProfile: object;
	contacts: object;
	bankAccounts: object;
	changePlan: object;
	fundsWithdrawal: object;
	editSuccess: boolean;
	editError: boolean;
	editMode: boolean;
}

const initialState: settingsState = {
	loading: false,
	message: intialMessage,
	myProfile: {},
	contacts: {},
	bankAccounts: {},
	changePlan: {},
	fundsWithdrawal: {},
	editSuccess: false,
	editError: false,
	editMode: false,
};

export const settingsSlice = createSlice({
	name: 'settings',
	initialState,
	reducers: {
		setLoadingSettings: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		setMessage: (state, action: PayloadAction<userMessage>) => {
			state.message = action.payload;
		},
		setMyProfile: (state, action: PayloadAction<object>) => {
			state.myProfile = action.payload;
		},
		setContacts: (state, action: PayloadAction<object>) => {
			state.contacts = action.payload;
		},
		setBankAccounts: (state, action: PayloadAction<object>) => {
			state.contacts = action.payload;
		},
		setChangePlan: (state, action: PayloadAction<object>) => {
			state.contacts = action.payload;
		},
		setFundsWithdrawal: (state, action: PayloadAction<object>) => {
			state.contacts = action.payload;
		},
		setEditSuccess: (state, action: PayloadAction<boolean>) => {
			state.editSuccess = action.payload;
		},
		setEditError: (state, action: PayloadAction<boolean>) => {
			state.editError = action.payload;
		},
		setEditMode: (state, action: PayloadAction<boolean>) => {
			state.editMode = action.payload;
		},
	},
});

export const { setLoadingSettings, setMessage, setMyProfile, setContacts, setEditSuccess, setEditError, setEditMode } =
	settingsSlice.actions;

export const isLoading = (state: any) => state.settings.loading;
export const getMessage = (state: any) => state.settings.message;
export const getMyProfile = (state: any) => state.settings.myProfile;
export const getContacts = (state: any) => state.settings.contacts;
export const getEditSuccess = (state: any) => state.settings.editSuccess;
export const getEditMode = (state: any) => state.settings.editMode;

export default settingsSlice.reducer;
